/**
 * created by lei lei
 *横向管控Action
 */
import request from "../../../base/request";
import {applicationName} from "../../../utils";

let host = '/newmedia-data-consumer/';
let businessHost = "/newmedia-business-server/";
const Apis = {
    getMediaCount: host + 'media/getMediaCount',//获取媒体数
    getDeptAll: '/cm-sites-sys/dept/getAll',//获取媒体部门（全部权限）
    getCurrentDeptByIds:  '/cm-sites-sys/dept/getByIds',//获取当前部门（部门和个人权限）
    getDeptAndSon: host + 'dept/getDeptAndSon',//获取当前媒体部门

    //---------媒体总览-------------
    // wechatTodayQuery: host + 'media/wechatTodayQuery',//获取微信今日活跃数
    // weiboTodayQuery: host + 'media/weiboTodayQuery',//获取微信今日活跃数
    // douyinTodayQuery: host + 'media/douyinTodayQuery',//获取抖音今日活跃数
    queryMediaTodayActive: host + 'overview/activeAccountNum',//获取媒体活跃数
    queryMediaStatusNum: businessHost + 'newMedia/newMediaOverview',//获取各媒体不同状态数
    queryLatestMaterial: host + 'overview/getLatestPublish',//获取最新文章

    getWechatDetails: host + 'media/wechat/detail',//根据最新文章关联id获取微信详情
    getWeiBoDetails: host + 'media/weibo/detail',//根据最新文章关联id获取微博详情
    getdouyinDetails: host + 'media/douyin/detail',//根据最新文章关联id获取抖音详情

    getWechatDangerDetails: host + 'contentManager/weChatDetail',//根据危险内容提醒关联id获取微信详情
    getWeiBoDangerDetails: host + 'contentManager/weiboDetail',//根据危险内容提醒关联id获取微博详情
    getDouyinDangerDetails: host + 'contentManager/douyinDetail',//根据危险内容提醒关联id获取抖音详情

    //-----------------媒体账号管理-------------
    getMediaList: host + 'media/list',//获取账号列表
    getMediarecord: host + 'mediarecord',//根据id获取媒体详情
    mediarecord: host + 'mediarecord/',//新增媒体备案
    delMediaById:"/cm-sites-" + applicationName() + '/media/delMediaById/',//删除账号


    //---------内容管理-------------
    getwechatList: host + 'contentManager/weChatContent',//获取微信列表
    getWeiboList: host + 'contentManager/blogContent',//获取微博列表
    getDouyinList: host + 'contentManager/douyinContent',//获取微博列表

    //--------统计分析---------------
    getWechatStatisticsQuery: host + 'weChatStatistics/summary',//获取微信统计汇总数据
    getWeiboStatisticsQuery: host + 'weiboStatistics/summary',//获取微博统计汇总数据
    getDouyinStatisticsQuery: host + 'douyinStatistics/statistics',//获取抖音统计汇总数据


    getWechatAccountDetailQuery: host + 'weChatStatistics/detail',//获取微信账号明细
    getWeiboAccountDetailQuery: host + 'weiboStatistics/detail',//获取微博账号明细
    getDouyinAccountDetailQuery: host + 'douyinStatistics/detailstatistics',//获取抖音账号明细

    getWechatDailyStatistics: host + 'weChatStatistics/statistics',//获取微信趋势分析数据
    getWeiboDailyStatistics: host + 'weiboStatistics/daily',//获取微博趋势分析数据
    getDouyinDailyStatistics: host + 'douyinStatistics/dailyStatistics',//获取抖音趋势分析数据
    getWeChatData: host + 'weChatStatistics/newMedias',//获取微信媒体数据
    getWeiBoData: host + 'weiboStatistics/newMedias',//获取微博媒体数据
    getDouYinData: host + 'douyinStatistics/newMedias',//获取抖音媒体数据



    getWechatHotTop10: host + 'weChatStatistics/hotTop10',//获取微信热门文章
    getWeiboHotTop10: host + 'weiboStatistics/weiboHotTop10',//获取热门文章
    getDouyinHotTop10: host + 'douyinStatistics/hotTop10',//获取抖音热门文章

    getWeChatFansTop10: host + 'weChatStatistics/activeAccount',//获取微信粉丝数
    getWeiBoFansTop10: host + 'weiboStatistics/fansTop10',//获取微博粉丝数
    getDouYinFansTop10: host + 'douyinStatistics/fansTop10',//获取抖音粉丝数
    //-----------------------------系统检测------------------
    getSystemSensitiveCheckListQuery: businessHost + 'contentSecurity/systemSensitiveCheckListQuery',//获取系统检测列表
    getContentSecurityExcel: businessHost + 'contentSecurity/excel',//系统检测导出列表
    getAllNewMediaTypeNoPage: businessHost + 'newMediaType/getAllNewMediaTypeNoPage',//获取所有媒体平台，不翻页

    //---------------------手动检测-----------------
    getSensitiveCheckTaskListQuery: businessHost + 'contentSecurity/sensitiveCheckTaskListQuery',//获取手动检测列表
    startContentSecurity: businessHost + 'contentSecurity/',//手动检测列表开始检测接口
    getMediaByType: businessHost + 'newMedia/allNewMediaList',
    customSensitiveCheckListQuery: businessHost + 'contentSecurity/customSensitiveCheckListQuery',//根据手动检测id获取结果
    getContentSecurityexcelCustom: businessHost + 'contentSecurity/excelCustom',//手动检测结果，导出表格
    getSensitiveMediaTop10: businessHost + 'contentSecurity/sensitiveMediaTop10',//获取检测报告


};

//获取媒体数，媒体账号管理和统计分析使用
export function getMediaCount(body, callBack) {
    let url = Apis.getMediaCount;
    request({url, body, callBack});
}

//获取所有部门
export function getDeptAll(callBack) {
    let url = Apis.getDeptAll;
    request({url, callBack})
}
//获取所有部门
export function getCurrentDeptByIds(body, callBack) {
    let url = Apis.getCurrentDeptByIds;
    request({url, body, method:"post",contentType: "json", callBack})
}
//获取当前
export function getDeptAndSon(strIds,callBack) {
    let url = Apis.getDeptAndSon+'?strIds='+strIds;
    request({url, callBack});
}

//---------------------媒体总览---------------

// 获取各媒体及总的活跃数
export function activeAccountNum(body, callBack) {
    let url = Apis.queryMediaTodayActive;
    request({url , body, callBack})
}

// 获取各媒体不同的状态数
export function mediaStatusNum(body, callBack) {
    let url = Apis.queryMediaStatusNum;
    request({url , body, callBack})
}

//获取最新文章
export function queryLatestMaterial(body, callBack) {
    let url = Apis.queryLatestMaterial;
    request({url,body, callBack})
}
//根据最新文章关联id获取微信详情
export function getWechatDetails(id, callBack) {
    let url = Apis.getWechatDetails + '?id=' + id;
    request({url, callBack});
}


//根据最新文章关联id获取微博详情
export function getWeiBoDetails(id, callBack) {
    let url = Apis.getWeiBoDetails + '?id=' + id;
    request({url, callBack});
}

//根据最新文章关联id获取抖音详情
export function getdouyinDetails(body, callBack) {
    let url = Apis.getdouyinDetails ;
    request({url, body, method:"post", callBack});
}

///////////////////////媒体总览危险内容提醒////////////////////

//根据最新文章关联id获取微信详情
export function getWechatDangerDetails(id, callBack) {
    let url = Apis.getWechatDangerDetails + '?resourceId=' + id;
    request({url, callBack});
}


//根据最新文章关联id获取微博详情
export function getWeiBoDangerDetails(id, callBack) {
    let url = Apis.getWeiBoDangerDetails + '?resourceId=' + id;
    request({url, callBack});
}

//根据最新文章关联id获取抖音详情
export function getDouyinDangerDetails(id, callBack) {
    let url = Apis.getDouyinDangerDetails + '?resourceId=' + id ;
    request({url, callBack});
}

//----------------------账号管理----------
//获取账号列表
export function getMediaList(body, callBack) {
    let url = Apis.getMediaList;
    request({url, body, callBack});
}

//获取媒体详情
export function getMediarecord(id, callBack) {
    let url = Apis.getMediarecord + '/' + id;
    request({url, callBack});
}

//新增备案
export function addMediaRecord(body, updateTime, callBack) {
    let url;
    if (updateTime) {
        url = `${Apis.mediarecord}?updateTime=${updateTime}`;
    } else {
        url = Apis.mediarecord;
    }
    request({url, body, method:"post", callBack});
}

//-------------------------内容管理-----------
//获取微信列表
export function getwechatList(body, callBack) {
    let url = Apis.getwechatList;
    request({url, body, callBack})
}

//获取微博列表
export function getWeiBoList(body, callBack) {
    let url = Apis.getWeiboList;
    request({url, body, callBack})
}

//获取抖音列表
export function getDouyinList(body, callBack) {
    let url = Apis.getDouyinList;
    request({url, body, callBack})
}

//--------------------统计分析------------------------

//获取微信统计汇总数据
export function getWechatStatisticsQuery(body, callBack) {
    let url = Apis.getWechatStatisticsQuery;
    request({url, body, method:"post", contentType:"json", callBack});
}

//获取微博统计汇总数据
export function getWeiboStatisticsQuery(body, callBack) {
    let url = Apis.getWeiboStatisticsQuery;
    request({url, body,  method:"post", contentType:"json", callBack});
}

//获取抖音统计汇总数据
export function getDouyinStatisticsQuery(body, callBack) {
    let url = Apis.getDouyinStatisticsQuery;
    request({url, body, method:"post", contentType:"json",callBack})
}

//获取微信账号明细
export function getWechatAccountDetailQuery(body, callBack) {
    let url = Apis.getWechatAccountDetailQuery;
    request({url, body, method:"post", contentType:"json", callBack})
}


//获取微博账号明细
export function getWeiboAccountDetailQuery(body, callBack) {
    let url = Apis.getWeiboAccountDetailQuery;
    request({url, body, method:"post", contentType:"json", callBack})
}

//获取微博账号明细
export function getDouyinAccountDetailQuery(body, callBack) {
    let url = Apis.getDouyinAccountDetailQuery;
    request({url, body, method:"post", contentType:"json",callBack})
}

//获取微信趋势分析
export function getWechatDailyStatistics(body, callBack) {
    let url = Apis.getWechatDailyStatistics;
    request({url, body, method:"post", contentType:"json",callBack})
}

//获取微博趋势分析
export function getWeiboDailyStatistics(body, callBack) {
    let url = Apis.getWeiboDailyStatistics;
    request({url, body, method:"post", contentType:"json", callBack})
}

//获取抖音趋势分析
export function getDouyinDailyStatistics(body, callBack) {
    let url = Apis.getDouyinDailyStatistics;
    request({url, body, method:"post", contentType:"json", callBack})
}

//获取微信热门文章
export function getWechatHotTop10(body, callBack) {
    let url = Apis.getWechatHotTop10;
    request({url, body, method: "post", contentType: "json", callBack})
}

//获取微博热门文章
export function getWeiboHotTop10(body, callBack) {
    let url = Apis.getWeiboHotTop10;
    request({url, body, method: "post", contentType: "json",callBack})
}

//获取抖音热门文章
export function getDouyinHotTop10(body, callBack) {
    let url = Apis.getDouyinHotTop10;
    request({url, body, method: "post", contentType: "json", callBack})
}

//获取微信粉丝列表
export function getWeChatFansTop10(body, callBack) {
    let url = Apis.getWeChatFansTop10;
    request({url, body, method: "post", contentType: "json", callBack})
}

//获取微博粉丝列表
export function getWeiBoFansTop10(body, callBack) {
    let url = Apis.getWeiBoFansTop10;
    request({url, body, method: "post", contentType: "json", callBack})
}

//获抖音粉丝列表
export function getDouYinFansTop10(body, callBack) {
    let url = Apis.getDouYinFansTop10;
    request({url, body, method: "post", contentType: "json", callBack})
}

//--------------------------系统检测模块接口------------------
//获取系统检测列表。
export function getSystemSensitiveCheckListQuery(body, callBack) {
    let url =Apis.getSystemSensitiveCheckListQuery;
    request({url, body, callBack});
}

//系统检测导出表格
export const getContentSecurityExcel = Apis.getContentSecurityExcel;

//获取手动检测列表。
export function getSensitiveCheckTaskListQuery(body, callBack) {
    let url = Apis.getSensitiveCheckTaskListQuery;
    request({url, body, callBack})
}

///根据部门id获取媒体
export function getAllMediaByDeptIdOrType(body, callBack) {
    let url = Apis.getMediaByType;
    request({url, body, method:"post", contentType:"json", callBack})
}

///开始检测接口
export function startContentSecurity(body, callBack) {
    let url = Apis.startContentSecurity + '?startDate=' + body.startDate + '&endDate=' + body.endDate;
    request({url, body, method:"post", contentType:"json", callBack});
}

///根据手动检测id获取检测结果
export function customSensitiveCheckListQuery(body, callBack) {
    let url = Apis.customSensitiveCheckListQuery;
    request({url, body, callBack});
}

//导出检测结果
export const getContentSecurityexcelCustom = Apis.getContentSecurityexcelCustom;
///获取检测报告
export function getSensitiveMediaTop10(body, callBack) {
    let url = Apis.getSensitiveMediaTop10;
    request({url, body, callBack});
}

//账号管理删除
export const delMediaById = (body, callBack) => {
    request({url:Apis.delMediaById, body, callBack, loading:false});
};

//账号管理删除
export const getAllNewMediaTypeNoPage = (callBack) => {
    request({url:Apis.getAllNewMediaTypeNoPage, callBack, loading:false});
};

//公众号媒体数据
export const getWeChatData = (body, callBack) => {
    request({url:Apis.getWeChatData, body, method:"post", contentType:"json", callBack, loading:false});
};

//微博媒体数据
export const getWeiBoData = (body, callBack) => {
    request({url:Apis.getWeiBoData, body, method:"post", contentType:"json", callBack, loading:false});
};

//抖音媒体数据
export const getDouYinData = (body, callBack) => {
    request({url:Apis.getDouYinData, body, method:"post", contentType:"json", callBack, loading:false});
};